export const formatSearchQuery = (query: any) => {
  if (!query) {
    return "";
  }

  // Filter out undefined and null values
  const filteredQuery = Object.entries(query).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {} as Record<string, any>);

  // If no valid parameters remain, return empty string
  if (Object.keys(filteredQuery).length === 0) {
    return "";
  }

  // Build query string with proper array support
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filteredQuery)) {
    if (Array.isArray(value)) {
      for (const item of value) {
        params.append(key, String(item));
      }
    } else {
      params.append(key, String(value));
    }
  }

  return `?${params.toString()}`;
};